import React from "react";
import { useHistory } from "react-router-dom";
import Tooltip from "react-tooltip";
import { useRecoilState, useRecoilValue } from "recoil";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../PermissionsConstants";
import {
  ChevronRightIcon,
  InformationCircleIcon,
  QrCodeIcon,
} from "@heroicons/react/24/solid";
import { useGetProducerCodeCount } from "../../CarrierAgreementMgmt/ProducerCode/hooks/useGetProducerCodeCount";
import DashboardCard2 from "../../../components/DashboardCard2";

const NewProducerCodeCard = () => {
  const { data: prodCodeCount, isLoading } = useGetProducerCodeCount();
  const totalprodCodeCount = prodCodeCount && prodCodeCount?.data;

  const history = useHistory();
  const modulePermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_producercode_view;
  const userPermissions = useRecoilValue(permissionsSelector);

  return (
    <>
      <div
        className="flex w-full bg-secondary lg:p-4 md:p-2 rounded-lg cursor-pointer"
        onClick={() => {
          if (userPermissions.includes(modulePermission)) {
            const urlPath = "/carrieragreementmgmt/producercodeconfig";
            history.push({
              pathname: urlPath,
            });
          }
        }}
      >
        <DashboardCard2
          text="Producer Code"
          count={isLoading ? "..." : totalprodCodeCount}
          image={<QrCodeIcon className="text-white rounded-lg h-7 w-7 p-1" />}
          hasAccess={userPermissions.includes(modulePermission) ? true : false}
        />
        {userPermissions.includes(modulePermission) ? (
          ""
        ) : (
          <div className="relative">
            <Tooltip
              id="producer code"
              place="top"
              effect="solid"
              type="info"
              border={false}
              arrowColor="#3a3b3c"
              // borderColor="#0078d7"
              backgroundColor="#3a3b3c"
              textColor="white"
            />
            <InformationCircleIcon
              data-tip={
                "Contact your System Administrator to secure access to this module."
              }
              data-for="producer code"
              className="h-6 w-6 mr-2 text-white"
            />
          </div>
        )}
      </div>

      {/* ) : ( */}
      {/* <div className="flex w-full bg-tertiary lg:p-4 md:p-2 rounded-lg cursor-pointer" />
      )} */}
    </>
  );
};

export default NewProducerCodeCard;
